export default __webpack_public_path__ + "static/20-1b1a787420a3867252287c8ff63fdbf9.jpg";